import { makePieActionObjs } from "shared/imports/pieActionGenerators"
import { prependAppName } from "shared/imports/sharedHelperFunctions"

export const appName = "@@texting/"

const validateKeywordObjs = makePieActionObjs("validate", "keyword")
export const validateKeywordActionDict = prependAppName(appName, validateKeywordObjs.pieDict)

const agreeToTextingObjs = makePieActionObjs("update", "accepted_texting_terms")
export const agreeToTextingActionDict = prependAppName(appName, agreeToTextingObjs.pieDict)

const TextingActions = {
    ...prependAppName(appName, {
        ...validateKeywordObjs.actionTypes,
        ...agreeToTextingObjs.actionTypes,
    }),
}

export default TextingActions
